









import { Vue, Component } from 'vue-property-decorator';

import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';

@Component({ components: { CabeceraModal } })
export default class CabeceraModalVisualizacion extends Vue {}
